import {assert} from 'Asserts';
import {BenchlingExpression, BenchlingExpressionType} from 'benchling-expressions/BenchlingExpressionTypes';
import {assertNever, DeepPartial} from 'util/Types';

export function validateCompleteBenchlingExpression(
  partialExpression: DeepPartial<BenchlingExpression>
): partialExpression is BenchlingExpression {
  if (partialExpression.type == null) {
    return false;
  }
  if (partialExpression.type === BenchlingExpressionType.CONSTANT_VALUE) {
    return partialExpression.itemType != null && partialExpression.value !== undefined;
  } else if (partialExpression.type === BenchlingExpressionType.CONTEXT_VARIABLE) {
    return partialExpression.itemType != null && partialExpression.contextKey !== undefined;
  } else if (partialExpression.type === BenchlingExpressionType.SCHEMA_LOOKUP) {
    if (
      partialExpression.lookupConfig == null ||
      partialExpression.schema === undefined ||
      partialExpression.expression == null
    ) {
      return false;
    }
    return validateCompleteBenchlingExpression(partialExpression.expression);
  } else if (partialExpression.type === BenchlingExpressionType.FUNCTION) {
    return (
      partialExpression.name != null &&
      partialExpression.parameters != null &&
      partialExpression.parameters?.every(
        (p) => p?.name != null && p.expression != null && validateCompleteBenchlingExpression(p.expression)
      )
    );
  } else {
    assert(false, `Found unexpected expression type ${assertNever(partialExpression.type)}`);
  }
  return true;
}
